module.exports = __webpack_public_path__ + "static/media/company2@2x.a2954960.png";